import slideTo from './slideTo';
import slideToLoop from './slideToLoop';
import slideNext from './slideNext';
import slidePrev from './slidePrev';
import slideReset from './slideReset';
import slideToClosest from './slideToClosest';
import slideToClickedSlide from './slideToClickedSlide';

export default {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide,
};



// WEBPACK FOOTER //
// ../src/components/core/slide/index.js